import { DEFAULTFONTS, DESIGN } from "../actions";
import { PRODUCTVARIANT } from "../actions/index";

const initialState = {
  fonts: {},
  categories: {},
  allowed_font_categories: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DEFAULTFONTS.SUCCESS:
      return {
        ...state,
        fonts: action.response.entities.font || [],
        categories: action.response.entities.category || [],
      };
    case DESIGN.SUCCESS:
      return {
        ...state,
        allowed_font_categories:
          action.response.product_variant.font_categories || [],
      };
    case PRODUCTVARIANT.SUCCESS:
      return {
        ...state,
        allowed_font_categories: action.response.font_categories || [],
      };
    default:
      return state;
  }
}
